// removed by extract-text-webpack-plugin
module.exports = {"add-lesson-form":"add-lesson-form","same-dates-message":"same-dates-message","Select-value":"Select-value","Select-menu-outer":"Select-menu-outer","button-section":"button-section"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Forms/EditLesson/EditLesson.scss
// module id = 9bC3
// module chunks = 0